import i18nInstance from 'i18n/i18nInstance'
import { useTranslation, withI18nContext } from '@mc/i18n'
import classes from './Heading.module.scss'

const HeadingComp = () => {
  const { t } = useTranslation('@mc/next')

  return (
    <div className='row no-gutters'>
      <div className='col-12 col-lg-10'>
        <div className='mc-mt-8 mc-mt-md-12'>
          <div className='row no-gutters'>
            <div className='col-12 col-md-9 col-lg-12'>
              <h1 className='mc-text-d2 mc-text--brand mc-text--uppercase mc-p-0 mc-mb-2'>
                {t('home.hero.title')}
              </h1>
            </div>
          </div>
          <div className='row no-gutters'>
            <div className='col-9 col-lg-12'>
              <p className='mc-p-0 mc-text--bold mc-text-color--medium'>
                {t('home.hero.subtitle')}
              </p>
            </div>
          </div>
          <div className={`mc-my-6 ${classes.underscore}`} />
        </div>
      </div>
    </div>
  )
}

export const Heading = withI18nContext(i18nInstance)(HeadingComp)
